import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  buttonContainerStyle,
  containerStyle,
  iconBackgroundStyle,
  iconContainerStyle,
  textContainerStyle,
  textStyle
} from './styles.ts';

import HeartSimpleShape from '@/components/common/svg/shapes/HeartSimpleShape.tsx';
import ArrowRightShape from '@/components/common/svg/shapes/ArrowRightShape.tsx';
import { routes } from '@/navigation/routes.tsx';
import { useSummariesStore } from '@/store/useSummariesStore.ts';
import { getPlural } from '@/utils/getPlural.ts';

export const PeopleLikeMe = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();
  const { likesCount } = useSummariesStore();

  const hasLikes = useMemo(
    () => likesCount !== undefined && likesCount > 0,
    [likesCount]
  );

  const navigateToLikes = () => {
    navigate(routes.likes);
  };

  const likesTitle = useMemo(
    () =>
      getPlural(
        likesCount,
        t,
        {
          zero: 'chats.no_likes',
          one: 'chats.one_like',
          singular: 'chats.x_like',
          few: 'chats.up_to_five_likes',
          many: 'chats.x_likes'
        },
        'likesCount'
      ),
    [likesCount]
  );

  return (
    <motion.div
      style={containerStyle}
      onTap={navigateToLikes}
      whileTap={{ opacity: 0.8 }}
    >
      <div style={iconContainerStyle}>
        <div style={iconBackgroundStyle}>
          <HeartSimpleShape
            width={35}
            height={35}
            fillColor="#ffffff"
            style={{ marginLeft: 1, marginTop: 1 }}
          />
        </div>
      </div>
      <div style={textContainerStyle}>
        <p style={textStyle}>{likesTitle}</p>
      </div>
      <div style={buttonContainerStyle(hasLikes)}>
        <ArrowRightShape width={15} height={15} />
      </div>
    </motion.div>
  );
};